import { ReactNode } from 'react';
import { NavigateOptions, To, useNavigate } from 'react-router-dom';
import Button from './Button';

interface NavButtonProps {
  to: To;
  relative?: NavigateOptions['relative'];
  children?: ReactNode;
  sx?: object;
  [prop: string]: any;
}

export default function NavButton({ to, relative = 'route', children = null, sx = {}, ...props }: NavButtonProps) {
  const navigate = useNavigate();
  const go = () => navigate(to, { relative } as NavigateOptions);
  return (
    <Button
      onClick={go}
      {...props}
      sx={{
        ...sx
      }}
    >
      {children}
    </Button>
  );
}
